import { CircleSolidIcon, StackIcons, WarningIcon } from '@dhl-ui/icons'

export const WarningYellowIcon = () => (
  <StackIcons variant="centered" sx={{ mr: 1 }}>
    <CircleSolidIcon color="secondary" />
    <WarningIcon />
  </StackIcons>
)
